import { getStartedNavConfig } from './getStarted';

/**
 * The array of secondary nav configs for the `/getting-started` section of the site.
 */
export default (() => [getStartedNavConfig]);